/** Outcome returned by the live-track bulk-create mutation on Track Matching. */
export type LiveTrackBulkSaveResult = {
  createdGroupCount: number;
  errorSummaries: string[];
};

/**
 * Whether leaving the page (clearing local track-matching state) is safe after a save attempt.
 * Partial success, validation errors, and empty created[] must keep the user on the page.
 */
export function liveTrackBulkSaveAllowsLeave(result: LiveTrackBulkSaveResult): boolean {
  return result.errorSummaries.length === 0 && result.createdGroupCount > 0;
}
